import { ChevronLeft, ChevronRight } from "lucide-react";
import { getCurrentPeriodIndex } from "../utils/periodRange";

export default function TimeNavigator({
    view,
    setView,
    year,
    setYear,
    periodIndex,
    setPeriodIndex
}) {
    const views = [
        { id: "week",     label: "W" },
        { id: "month",    label: "M" },
        { id: "quarter",  label: "Q" },
        { id: "tertial",  label: "T" },
        { id: "halfyear", label: "H" },
        { id: "year",     label: "Y" }
    ];

    const getCenterLabel = () => {
        if (view === "week")     return `${year} · Week ${periodIndex + 1}`;
        if (view === "month")    return `${year} · Month ${periodIndex + 1}`;
        if (view === "quarter")  return `${year} · Q${periodIndex + 1}`;
        if (view === "tertial")  return `${year} · T${periodIndex + 1}`;
        if (view === "halfyear") return `${year} · H${periodIndex + 1}`;
        return `${year}`;
    };

    const limits = { week: 52, month: 12, quarter: 4, tertial: 3, halfyear: 2, year: 1 };

    const moveBackward = () => {
        if (view === "year") { setYear(y => y - 1); return; }
        if (periodIndex > 0) {
            setPeriodIndex(i => i - 1);
        } else {
            setYear(y => y - 1);
            setPeriodIndex(limits[view] - 1);
        }
    };

    const moveForward = () => {
        if (view === "year") { setYear(y => y + 1); return; }
        if (periodIndex < limits[view] - 1) {
            setPeriodIndex(i => i + 1);
        } else {
            setYear(y => y + 1);
            setPeriodIndex(0);
        }
    };

    const changeView = (newView) => {
        setView(newView);
        // Land on the period that contains today rather than always jumping to
        // January / Q1 — switching M -> Q on the current year should stay on
        // live data. Other years still start at their first period.
        setPeriodIndex(getCurrentPeriodIndex(newView, year));
    };

    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 16px",
            borderRadius: "10px",
            border: "1px solid #e5e7eb",
            background: "#ffffff",
        }}>

            {/* Selector de vista — izquierda */}
            <div style={{ display: "flex", gap: 4 }}>
                {views.map(v => (
                    <button
                        key={v.id}
                        onClick={() => changeView(v.id)}
                        style={{
                            padding: "5px 14px",
                            borderRadius: "6px",
                            border: view === v.id
                                ? "1px solid #1D9E75"
                                : "1px solid transparent",
                            background: view === v.id
                                ? "rgba(29,158,117,0.1)"
                                : "transparent",
                            color: view === v.id
                                ? "#0F6E56"
                                : "#9ca3af",
                            fontSize: "12px",
                            fontWeight: 600,
                            cursor: "pointer",
                            transition: "all 0.15s ease",
                        }}
                    >
                        {v.label}
                    </button>
                ))}
            </div>

            {/* Año / periodo — centro */}
            <div style={{
                fontSize: "15px",
                fontWeight: 600,
                color: "#111827",
                letterSpacing: "0.02em",
            }}>
                {getCenterLabel()}
            </div>

            {/* Flechas — derecha */}
            <div style={{ display: "flex", gap: 6 }}>
                <button onClick={moveBackward} style={{
                    width: 28,
                    height: 28,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "6px",
                    border: "1px solid #e5e7eb",
                    background: "transparent",
                    color: "#6b7280",
                    cursor: "pointer",
                    transition: "all 0.15s ease",
                }}>
                    <ChevronLeft size={14} />
                </button>
                <button onClick={moveForward} style={{
                    width: 28,
                    height: 28,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "6px",
                    border: "1px solid #e5e7eb",
                    background: "transparent",
                    color: "#6b7280",
                    cursor: "pointer",
                    transition: "all 0.15s ease",
                }}>
                    <ChevronRight size={14} />
                </button>
            </div>

        </div>
    );
}